// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"e84609e6","3818":"fa9a404c","5122":"1f3a2121","5912":"aec78970","9224":"d57b2874"}[chunkId] + ".css";
};